
import { useState, useEffect } from 'react';
import { useContentOperations } from './useContentOperations';
import { useDialogManagement } from './useDialogManagement';
import { useCivicEducationRelationships } from './useCivicEducationRelationships';
import { CivicEducationItem } from '@/types/civic-education';

export const useCivicEducationManagement = () => {
  const [contentType, setContentType] = useState('all');
  const [linkedCards, setLinkedCards] = useState<any[]>([]);
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);
  
  const {
    items,
    isLoading,
    fetchContent,
    saveContent,
    deleteContent
  } = useContentOperations();

  const { fetchRelationships } = useCivicEducationRelationships();

  const {
    dialogOpen,
    setDialogOpen,
    currentItem,
    setCurrentItem,
    isEditing,
    handleOpenDialog
  } = useDialogManagement(contentType);

  // Refresh content when the content type changes
  useEffect(() => {
    fetchContent();
  }, [contentType]);

  // Fetch relationships when an item is selected for editing
  useEffect(() => {
    const loadRelationships = async () => {
      if (selectedItemId) {
        const relationships = await fetchRelationships(selectedItemId);
        setLinkedCards(relationships);
      }
    };
    
    if (selectedItemId) {
      loadRelationships();
    }
  }, [selectedItemId, fetchRelationships]);

  const handleSaveItem = async () => {
    if (!currentItem) return false;
    const result = await saveContent(currentItem, isEditing);
    if (result) {
      setDialogOpen(false);
      return true;
    }
    return false;
  };

  const handleEditWithRelationships = (item: CivicEducationItem) => {
    setSelectedItemId(item.id);
    handleOpenDialog(item);
  };

  return {
    items,
    isLoading,
    dialogOpen,
    setDialogOpen,
    currentItem,
    setCurrentItem,
    isEditing,
    contentType,
    setContentType,
    linkedCards,
    setLinkedCards,
    handleOpenDialog,
    handleSaveItem,
    handleDeleteItem: deleteContent
  };
};
